import type { MouseEventHandler } from 'react';

interface Props {
  onNext: MouseEventHandler<HTMLButtonElement>;
}

export const Div0 = ({ onNext }: Props) => (
  <div className="flex flex-col items-center text-center text-white gap-4 max-w-2xl">
    <h1 className="text-2xl md:text-3xl italic mb-8">Félicitations !</h1>

    <span className="text-xl md:text-2xl italic">Vous avez accompli la&nbsp;mission que L’Atelier vous a confiée.</span>

    <button onClick={onNext} className="button mt-8">
      Suivant
    </button>
  </div>
);
